import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    source: String
  }

  copy(event) {
    event.preventDefault()

    const text = this.sourceValue.trim()
    const button = event.currentTarget

    navigator.clipboard.writeText(text).then(
      () => {
        const originalHTML = button.innerHTML
        const isIconButton = button.querySelector("svg")

        if (isIconButton) {
          // Replace icon with a check mark
          button.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>`
          button.classList.add("text-success")
        } else {
          button.textContent = "Copied!"
          button.classList.add("text-success")
        }

        setTimeout(() => {
          button.innerHTML = originalHTML
          button.classList.remove("text-success")
        }, 2000)
      },
      (err) => {
        console.error("Failed to copy text: ", err)
      }
    )
  }
}
